import { styled } from '@mui/system'
import Typography from '../../atoms/typography'

const Title = styled(Typography)``

export { Title }
